import { gql } from "@apollo/client";

const UPDATE_DEPLOYMENT = gql`
  mutation UpdateDeployment(
    $deploymentId: String!
    $enabled: Boolean
    $widgetConfig: JSON
  ) {
    updateDeployment(
      deploymentId: $deploymentId
      enabled: $enabled
      widgetConfig: $widgetConfig
    ) {
      success
      error
      deployment {
        id
        deploymentId
        enabled
        widgetConfig
        updatedAt
      }
    }
  }
`;

export default UPDATE_DEPLOYMENT;
